export default __webpack_public_path__ + "static/media/vgtrk.f1cb186c.svg";